module.exports = __webpack_public_path__ + "img/logo-4.b6aaacc8.png";